import { Badge } from "@package/subframe/components/Badge";

import { categoryColor } from "@/lib/category-display";

/**
 * Category chip shown as highlighted colour text. Uses the catalog/palette
 * colour when known, otherwise a neutral Subframe badge.
 */
export function CategoryPill({
  name,
  slug,
  color,
}: {
  name: string;
  slug?: string;
  color?: string;
}) {
  const tint = categoryColor(slug, color);
  if (!tint) {
    return <Badge variant="neutral">{name}</Badge>;
  }
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-caption-bold font-caption-bold"
      style={{ color: tint, backgroundColor: `${tint}1A` }}
    >
      {name}
    </span>
  );
}
